
<app-layout>
    <mat-toolbar class="page-header" role="heading">
      <mat-tab-group 
        *ngIf="currentEmployeeDetails.userType === 'Employee'"
        [(selectedIndex)]="selectedTabIndex" 
        setColor="primaryColour"
        mat-stretch-tabs="false" 
        mat-align-tabs="center"
      >
        <mat-tab *appHasFeature="features.TAB_HOME">
          <ng-template mat-tab-label>
            <mat-icon class="material-icons-outlined">home</mat-icon>
  
            <span appLocalizationPopupDirective [localizationCode]="'Homepage-Home'">
              {{ 'Homepage-Home' | translate: {Default: "Home"} }}
            </span>
          </ng-template>

          <ng-template matTabContent>
            <div class="content">
              <app-welcome-message *ngIf="!isMobile"></app-welcome-message>
              
              <div class="space-between">
                <app-articles-display 
                  *appHasFeature="features.TAB_ANNOUNCEMENTS"
                  [title]="'Homepage-CompanyArticles'" 
                  region="ANNOUNCEMENTS">
                </app-articles-display>
              </div>
              
              <div class="space-between">
                <app-articles-display 
                  *appHasFeature="features.TAB_WHATS_NEW"
                  [title]="'Homepage-WhatsNew'" 
                  region="WHATSNEW">
                </app-articles-display>
              </div>
              
              <div class="space-between">
                <app-quick-links-display
                  *appHasFeature="features.TAB_QUICK_LINKS"
                ></app-quick-links-display>
              </div>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab *appHasFeature="features.TAB_ABOUT_ME">
          <ng-template mat-tab-label>
            <mat-icon class="material-icons-outlined">emoji_people</mat-icon>
  
            <span appLocalizationPopupDirective [localizationCode]="'Homepage-AboutMe'">
              {{ 'Homepage-AboutMe' | translate: {Default: "About Me"} }}
            </span>
          </ng-template>

          <ng-template matTabContent>
            <app-about-me-section></app-about-me-section>
          </ng-template>
        </mat-tab>

        <ng-container *appHasModuleAccess="modules.TIME_OFF">
          <mat-tab *appHasFeature="features.TAB_TIME_OFF">
            <ng-template mat-tab-label>
              <mat-icon class="material-icons-outlined">schedule</mat-icon>
    
              <span appLocalizationPopupDirective [localizationCode]="'Homepage-TimeOff'">
                {{ 'Homepage-TimeOff' | translate: {Default: "Time Off"} }}
              </span>
            </ng-template>
            
            <ng-template matTabContent>
              <div class="space-between">
                <app-articles-display 
                  *appHasFeature="features.TAB_TIME_OFF_GUIDES"
                  [title]="'Homepage-TimeOffGuides'" 
                  region="TIMEOFFGUIDES">
                </app-articles-display>
              </div>
  
              <div class="space-between">
                <app-time-off-homepage-section></app-time-off-homepage-section>
              </div>
            </ng-template>
          </mat-tab>
        </ng-container>

        <ng-container *appHasModuleAccess="modules.PERFORMANCE">
          <mat-tab *appHasFeature="features.TAB_PERFORMANCE">
            <ng-template mat-tab-label>
              <mat-icon class="material-icons-outlined">adjust</mat-icon>
    
              <span appLocalizationPopupDirective [localizationCode]="'Homepage-Goals'">
                {{ 'Homepage-Goals' | translate: {Default: "Goals"} }}
              </span>
            </ng-template>
  
            <ng-template matTabContent>
              <app-goals-section></app-goals-section>
            </ng-template>
  
          </mat-tab>
        </ng-container>
        
      </mat-tab-group>
    </mat-toolbar>

    <!-- <app-actionable-tasks-widget (emitTabChange)="changeTab($event)"></app-actionable-tasks-widget> -->
        
        <!-- <app-whats-new-widget></app-whats-new-widget> -->
        
        <!-- <app-announcements-widget></app-announcements-widget> -->
        
        <!-- <app-quick-links-widget (changeTabIndexEmitted)="selectedTabIndex = $event"></app-quick-links-widget> -->
        
        <!-- <app-tasks-widget></app-tasks-widget> -->

        <!-- <app-engagement-survey></app-engagement-survey> -->

        <!-- <app-chat-gpt-widget></app-chat-gpt-widget> -->

    <!-- <div *ngIf="currentEmployeeDetails.userType === 'Employee'" class="content"> -->
      <!-- <ng-container *appHasModuleAccess="modules.PERFORMANCE">
        <ng-container *appHasFeature="features.PERFORMANCE">
          <app-homepage-employee-goals-widget *appHasFeature="features.PERFORMANCE_MY_GOALS" [employeeId]="user$.userId"></app-homepage-employee-goals-widget>
        </ng-container>
      </ng-container>

      <div class="time-off-row">
          <app-time-off-policy-widget *appHasModuleAccess="modules.TIME_OFF"
                                      (timeOffRequestCreated)="timeOffRequestCreated($event)"></app-time-off-policy-widget>
          <app-my-time-off-requests *appHasModuleAccess="modules.TIME_OFF"
                                    [refreshMyTimeOffRequest]="refreshMyTimeOffRequest"></app-my-time-off-requests>
      </div>

      <ng-container *appHasModuleAccess="modules.TOIL">
        <div class="time-off-row" *appHasFeature="features.TOIL">
          <app-toil-policy-widget 
            (toilRequestCreated)="toilRequestCreated($event)">
          </app-toil-policy-widget>
          
          <app-my-toil-requests 
            [refreshMyToilRequest]="refreshMyToilRequest">
          </app-my-toil-requests>
        </div>
      </ng-container>

      <mat-card *appHasFeature="features.BUY_SELL">
        <mat-card-content>
          <app-employee-buy-sell [employeeId]="user$.userId"></app-employee-buy-sell>
        </mat-card-content>
      </mat-card>


      <app-schedule-widget *appHasModuleAccess="modules.TIME_OFF"></app-schedule-widget> -->




      <!-- <app-employee-directory-widget></app-employee-directory-widget> -->


      <!-- <app-compensation-history-widget></app-compensation-history-widget> -->
      <!-- <app-tasks-widget></app-tasks-widget> -->
      <!-- <app-time-off-widget ></app-time-off-widget> -->
      <!-- <app-inbox-widget></app-inbox-widget>
      <app-birthdays></app-birthdays>
      <app-out-of-office-widget></app-out-of-office-widget> -->
      <!-- <app-news-and-holidays-widget></app-news-and-holidays-widget> -->
    <!-- </div> -->
  </app-layout>